import _get from 'lodash/get';

import { console } from 'react-redux-app/lib/modules/core/utils';


const authDataSelector = state => _get(state, 'auth.data');
export const getWebmasterId = state => _get(authDataSelector(state), 'id');

export const getIsWebmasterLogged = state => {
  const authData = authDataSelector(state);
  if (!authData) {
    console.consoleWarn(
      'Attempt to get auth data, but auth data is not loaded yet. '
      + 'You should call auth request before `isWebmasterLogged` function.'
    );
    return false;
  }

  return getWebmasterId(state) > 0;
};

export const getIsLoginRequestSending = state => _get(state, 'auth.isLoginRequestSending');
export const getIsActive = state => !!_get(authDataSelector(state), 'isActive');
export const getHasCampaigns = state => !!_get(authDataSelector(state), 'hasCampaigns');
export const getSuspendInfo = state => _get(authDataSelector(state), 'suspendInfo');
export const getNotifications = state => _get(authDataSelector(state), 'notifications');

export const getAuthError = state => _get(state, 'auth.errors.authError');
export const getLoginError = state => _get(state, 'auth.errors.loginError');

export const getAskUnsuspendError = state => _get(state, 'auth.errors.askUnsuspendError');
export const getChangePasswordError = state => _get(state, 'auth.errors.changePasswordError');
export const getDeleteAccountError = state => _get(state, 'auth.errors.deleteAccountError');
export const getDeleteNotificationError = state => _get(state, 'auth.errors.deleteNotificationError');
